import { render, staticRenderFns } from "./passing-statistic.vue?vue&type=template&id=5f638dda"
import script from "./passing-statistic.vue?vue&type=script&lang=js"
export * from "./passing-statistic.vue?vue&type=script&lang=js"
import style0 from "./passing-statistic.vue?vue&type=style&index=0&id=5f638dda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports